import { isEmpty, isNaN, isNumber } from 'lodash-es'

const isBlankValue = (value) => isEmpty(value) && (!isNumber(value) || isNaN(value))

export const getFormValue = (value, formValue, allowBlank = true) => {
  if (formValue === undefined) return value
  if (!allowBlank && isBlankValue(formValue)) return value

  return formValue
}
